<template>
  <collapsible-widget title="GEOMETRIA OBIEKTU" :accordion="accordion" :default-expanded="true">
    <b-form class="p-2">
      <b-form-group label="X:" label-for="newPointX" label-size="sm">
        <b-row v-show="xCoordinateInvalid">
          <b-col>
            <small class="text-danger">Wartość niepoprawna.</small>
          </b-col>
        </b-row>
        <b-form-input id="newPointX" size="sm" v-model.number="newPoint.x" placeholder="Wpisz długość geograficzną" type="number" :state="xCoordinateInvalid ? false : null"></b-form-input>
      </b-form-group>
      <b-form-group label="Y:" label-for="newPointY" label-size="sm">
        <b-row v-show="yCoordinateInvalid">
          <b-col>
            <small class="text-danger">Wartość niepoprawna.</small>
          </b-col>
        </b-row>
        <b-form-input id="newPointY" size="sm" v-model.number="newPoint.y" placeholder="Wpisz szerokość geograficzną" type="number" :state="yCoordinateInvalid ? false : null"></b-form-input>
      </b-form-group>
      <b-form-row>
        <b-col>
          <b-button class="btn-block" size="sm" variant="primary" @click="appendPoint" title="Dodaj">Dodaj</b-button>
        </b-col>
        <b-col>
          <b-button class="btn-block" size="sm" variant="outline-secondary" @click="endDrawing" title="Zakończ rysowanie">Zakończ rysowanie</b-button>
        </b-col>
      </b-form-row>
    </b-form>
    <div id="geometry-table" class="p-2">
      <table class="table table-sm">
        <thead>
          <tr>
            <th><small>lp.</small></th>
            <th><small>X</small></th>
            <th><small>Y</small></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(coordinate, index) in coordinates" :key="index">
            <td>{{ index + 1 }}</td>
            <td><input-number-decimal-format :arrayIndex="index" :coordinateIndex="0" :value="coordinate[0]" @valueChanged="changedGeometry"></input-number-decimal-format></td>
            <td><input-number-decimal-format :arrayIndex="index" :coordinateIndex="1" :value="coordinate[1]" @valueChanged="changedGeometry"></input-number-decimal-format></td>
            <td>
              <a href="#" title="Usuń" @click.prevent.stop="deletePoint(index)">
                <icon name="trash"></icon>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>   
  </collapsible-widget>
</template>

<script>
import { mapGetters } from 'vuex';
import { CONNECTION_ADD_FEATURE_POINT_MANUALLY, CONNECTION_POINT_CHANGED, CONNECTION_DELETE_POINT, CONNECTION_END_DRAWING } from '../store/mutations.type';
import CollapsibleWidget from "./CollapsibleWidget";
import InputNumberDecimalFormat from "./InputNumberDecimalFormat";

export default {
  name: 'RoadLaneAnalysisGeometry',
  props: {
    accordion: {
      type: String,
      default: 'panel'
    }
  },
  components: {
    CollapsibleWidget,
    InputNumberDecimalFormat
  },
  data() {
    return {
      coordinates: [],
      newPoint: { x: null, y: null },
      dirty: false
    };
  },
  computed: {
    ...mapGetters(['connectionAnalysisFeature']),
    xCoordinateInvalid() {
      return this.dirty && (this.newPoint.x == "" || this.newPoint.x == null || this.newPoint.x == undefined);
    },
    yCoordinateInvalid() {
      return this.dirty && (this.newPoint.y == "" || this.newPoint.y == null || this.newPoint.y == undefined);
    }
  },
  mounted() {
    if (this.connectionAnalysisFeature) {
      const self = this;
      this.connectionAnalysisFeature.on("change", evt => { self.coordinates = evt.target.getGeometry().getCoordinates(); });
    }
  },
  watch: {
    connectionAnalysisFeature(value) {
      if (value == null || value == undefined) {
        this.coordinates = [];
      } else {
        this.coordinates = this.connectionAnalysisFeature.getGeometry().getCoordinates();

        const self = this;
        this.connectionAnalysisFeature.on("change", evt => { self.coordinates = evt.target.getGeometry().getCoordinates(); });
      }
    }
  },
  methods: {
    appendPoint() {
      this.dirty = true;
      if (this.validateNewPointCoordinates()) {
        this.$store.commit(CONNECTION_ADD_FEATURE_POINT_MANUALLY, [this.newPoint.x, this.newPoint.y]);
        this.newPoint.x = this.newPoint.y = null;
        this.dirty = false;
      }
    },
    changedGeometry(value, index, coordinateIndex) {
      this.coordinates[index][coordinateIndex] = value;
      this.$store.commit(CONNECTION_POINT_CHANGED, { index: index, coordinates: this.coordinates[index] });
    },
    deletePoint(index) {
      this.$store.commit(CONNECTION_DELETE_POINT, index);
    },
    endDrawing() {
      this.$store.commit(CONNECTION_END_DRAWING);
    },
    validateNewPointCoordinates() {
      return !this.xCoordinateInvalid && !this.yCoordinateInvalid;
    }
  }
}
</script>